import type { FeatureManifest } from '../registry.js';

/**
 * "An update is available" (level version handshake): the server plays newer versions of
 * levels this client has and could not refresh itself (services/outdated.ts). Once per
 * session: reload on the web, the store on iOS and Android.
 */
export default {
  id: 'update',
  online: true,
  provides: ['appUpdate'],
  // before deliveries and results: an update may change what they show
  mapOrder: 8,
  mapDue: (a) => a.services.outdated.noticeDue,
  load: () => import('./index.js'),
} satisfies FeatureManifest;
